import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import axios from "axios"

export default class extends Controller {
  HEADERS = {
    "ACCEPT": "text/vnd.turbo-stream.html",
    "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").content
  }

  successCallback = (result) => {
    this.showFlashMessage("notice", this.successMessage)
  }

  executeError = (message) => {
    this.recordFiscalDeviceEvent("error", { Status: 2, Error: message }, "failure")
    this.showFlashMessage("alert", message)
  }

  connect() {
    this.kkmId = this.element.dataset.kkmId
    this.kkmInn = this.element.dataset.kkmInn
    this.kkmNum = this.element.dataset.kkmNum

    setTimeout(() => {
      this.getDataKKT()
    }, 100)
  }

  executeCommand = (data) => {
    try {
      if (window.KkmServer !== undefined) {
        if (typeof (data) === "string") data = JSON.parse(data)
        window.KkmServer.Execute(this.executeSuccess, data)
      } else {
        this.executeError(this.extensionUnavailableMessage)
      }
    } catch {
      this.executeError(this.genericErrorMessage)
    }
  }

  executeSuccess = (result) => {
    if (result.Status === 0) {
      const sessionState = result.Info.SessionState
      const command = result.Command

      if (command === "GetDataKKT") {
        if (result.Info.KktNumber !== this.kkmNum) {
          this.showFlashMessage("alert", this.factoryNumberMismatchMessage)
          return
        }

        if (sessionState === 1) {
          this.setClosedShiftState(this.kkmId, result, "shift_sync")
        } else if (sessionState === 2) {
          this.setOpenShiftState(this.kkmId, result, "shift_sync")
        } else {
          this.executeError(this.unknownShiftStatusMessage)
        }

        this.initKKM()
      } else if (command === "OpenShift") {
        this.setOpenShiftState(this.kkmId, result, "shift_open")
      } else if (command === "CloseShift") {
        this.setClosedShiftState(this.kkmId, result, "shift_close")
      } else if (command === "XReport") {
        this.recordFiscalDeviceEvent("x_report", result)
      }
      this.successCallback(result)
    } else if (result.Status === 1) {
      return
    } else if (result.Status === 2) {
      this.executeError(result.Error)
    }
  }

  initKKM = () => {
    const kkmButtonsElement = this.element.querySelector(".kkm-buttons")

    if (kkmButtonsElement) {
      kkmButtonsElement.style.display = "block"
    }

    const kkmUnitElement = this.element

    if (kkmUnitElement) {
      kkmUnitElement.classList.remove("border-gray-200", "bg-white")
      kkmUnitElement.classList.add("border-emerald-300", "bg-emerald-50")
    }

    const kkmTitleElement = this.element.querySelector(".kkm-title")

    if (kkmTitleElement) {
      kkmTitleElement.classList.remove("font-medium")
      kkmTitleElement.classList.add("text-emerald-700", "font-semibold")
    }

    const kkmAvailableElement = this.element.querySelector(".kkm-available")
    const kkmNotAvailableElement = this.element.querySelector(".kkm-not-available")

    if (kkmAvailableElement && kkmNotAvailableElement) {
      kkmNotAvailableElement.style.display = "none"
      kkmAvailableElement.style.display = "block"
    }
  }

  showFlashMessage = (type, message) => {
    axios.post("/flash_messages",
      { type: type, message: message },
      { headers: this.HEADERS }).then((response) => {
      Turbo.renderStreamMessage(response.data)
    })
  }

  getDataKKT(numDevice) {
    const data = {
      Command: "GetDataKKT",
      InnKkm: this.kkmInn,
      TaxVariant: "",
      IdCommand: this.guid()
    }
    this.executeCommand(data)
  }

  guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4())
  }

  openShift(e) {
    e.preventDefault()

    const cashierFullName = e.currentTarget.dataset.cashierFullName
    const cashierInn = e.currentTarget.dataset.cashierInn

    const data = {
      Command: "OpenShift",
      InnKkm: this.kkmInn,
      TaxVariant: "",
      NumDevice: 0,
      IdDevice: "",
      CashierName: cashierFullName,
      CashierVATIN: cashierInn,
      NotPrint: false,
      IdCommand: this.guid(),
    }

    this.executeCommand(data)
  }

  setOpenShiftState = (targetKkmId, result = {}, eventType = "shift_open") => {
    axios.post(`/cash_registers/${targetKkmId}/shift`, {
      fiscal_device_event: this.fiscalDeviceEventPayload(eventType, result)
    }, { headers: this.HEADERS })
      .then((response) => {
        Turbo.renderStreamMessage(response.data)
      })

    const openedElement = this.element.querySelector(".opened")
    const closedElement = this.element.querySelector(".closed")

    if (openedElement && closedElement) {
      closedElement.style.display = "none"
      openedElement.style.display = "flex"
    }
  }

  closeShift(e) {
    e.preventDefault()

    const cashierFullName = e.currentTarget.dataset.cashierFullName
    const cashierInn = e.currentTarget.dataset.cashierInn

    const data = {
      Command: "CloseShift",
      InnKkm: this.kkmInn,
      TaxVariant: "",
      NumDevice: 0,
      CashierName: cashierFullName,
      CashierVATIN: cashierInn,
      NotPrint: false,
      IdDevice: "",
      IdCommand: this.guid(),
    }

    this.executeCommand(data)
  }

  setClosedShiftState = (targetKkmId, result = {}, eventType = "shift_close") => {
    axios.patch(`/cash_registers/${targetKkmId}/shift`, {
      fiscal_device_event: this.fiscalDeviceEventPayload(eventType, result)
    }, { headers: this.HEADERS })
      .then((response) => {
        Turbo.renderStreamMessage(response.data)
      })

    const openedElement = this.element.querySelector(".opened")
    const closedElement = this.element.querySelector(".closed")

    if (openedElement && closedElement) {
      openedElement.style.display = "none"
      closedElement.style.display = "block"
    }
  }

  xReport(e) {
    e.preventDefault()

    const data = {
      Command: "XReport",
      InnKkm: this.kkmInn,
      TaxVariant: "",
      NumDevice: 0,
      IdCommand: this.guid()
    }

    this.executeCommand(data)
  }

  recordFiscalDeviceEvent(eventType, result = {}, status = "success") {
    if (!this.kkmId) return

    axios.post(`/cash_registers/${this.kkmId}/fiscal_events`, {
      fiscal_device_event: this.fiscalDeviceEventPayload(eventType, result, status)
    }, { headers: this.HEADERS })
  }

  fiscalDeviceEventPayload(eventType, result = {}, status = "success") {
    return {
      event_type: eventType,
      status: status,
      command: result.Command,
      message: result.Error,
      payload: result
    }
  }

  get successMessage() {
    return this.element.dataset.kkmSuccessMessage
  }

  get extensionUnavailableMessage() {
    return this.element.dataset.kkmExtensionUnavailableMessage
  }

  get genericErrorMessage() {
    return this.element.dataset.kkmGenericErrorMessage
  }

  get factoryNumberMismatchMessage() {
    return this.element.dataset.kkmFactoryNumberMismatchMessage
  }

  get unknownShiftStatusMessage() {
    return this.element.dataset.kkmUnknownShiftStatusMessage
  }
}
